// web/src/components/layout/ViewAsBanner.jsx
// Renders only when the user is viewing as a role different from their real one.

import { useAuth } from '../../lib/auth';

const ROLE_LABEL = {
  owner: 'Owner',
  manager: 'Manager',
  trainer: 'Trainer',
  groom: 'Groom',
  client: 'Client',
  service_provider: 'Service provider',
};

export default function ViewAsBanner() {
  const { user, viewAsRole, isViewingAs, setViewAsRole } = useAuth();

  if (!isViewingAs) return null;

  return (
    <div className="bg-amber-100 border-b border-amber-300 px-4 py-2 flex items-center justify-between text-sm">
      <span className="text-amber-900">
        Viewing as <strong>{ROLE_LABEL[viewAsRole] ?? viewAsRole}</strong>
      </span>
      <button
        onClick={() => setViewAsRole(null)}
        className="text-amber-900 underline hover:no-underline font-medium"
      >
        Switch back to {ROLE_LABEL[user.role] ?? user.role}
      </button>
    </div>
  );
}
